import { FadeUp } from "./FadeUp";

const USAGE = [
  {
    id: "meal-prep",
    img: "https://images.unsplash.com/photo-1601281366626-f664a1389746?crop=entropy&cs=srgb&fm=jpg&q=85",
    caption: "Meal prep made simple",
  },
  {
    id: "logging",
    img: "https://images.unsplash.com/photo-1780510418967-e0e3ae2109e2?crop=entropy&cs=srgb&fm=jpg&q=85",
    caption: "Log every set in the gym",
  },
  {
    id: "progress-check",
    img: "https://images.unsplash.com/photo-1580983693000-5654250f64d1?crop=entropy&cs=srgb&fm=jpg&q=85",
    caption: "Check progress anytime",
  },
];

export const UsageStrip = () => (
  <section className="py-14 md:py-20 px-6 bg-[#0A0A0B]">
    <div className="max-w-6xl mx-auto">
      <FadeUp>
        <h2 className="font-display text-3xl sm:text-4xl text-white text-center mb-10">
          HOW MEMBERS USE FORGE
        </h2>
      </FadeUp>
      <div className="grid sm:grid-cols-3 gap-5">
        {USAGE.map((u, i) => (
          <FadeUp key={u.id} delay={i * 0.08}>
            <div data-testid={`usage-card-${u.id}`} className="relative rounded-[24px] overflow-hidden h-64 border border-[#232326]">
              <img src={u.img} alt={u.caption} className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <p className="absolute bottom-5 left-5 right-5 text-white font-semibold">{u.caption}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
